export default "__VITE_ASSET__BTkqeBni__"